module.exports = __webpack_public_path__ + "static/img/logo_zhu8.2374e09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_zhu8.png
// module id = IhzO
// module chunks = 16